<ion-progress-bar color="dark" value="{{distance}}"></ion-progress-bar>
<p *ngIf="status == 2; else autoCancel">{{ 'MAIN_VIEW.RUNNING_TEXT' | translate}} {{duration}}</p>
<ng-template #autoCancel>
    <p *ngIf="status == 1">{{ 'MAIN_VIEW.PENDING_TEXT' | translate}} {{duration}}</p>
</ng-template>